<template>
  <div>
    <!-- 予約者情報表示セクション -->
    <div class="mb-2">
      <UserInfoConfirmSection :is-done-reservation="props.isDoneReservation" :on-click-guest-info-change-button="props.onClickGuestInfoChangeButton" :reservation-form-step2="form.step2" />
    </div>
    <AtomsBorder1 class="mb-4" />
    <!-- 体験タイトルと画像表示セクション -->
    <TitleWithImage class="mb-4" mode="SMALL" :img="props.thumbnailImageUrl ?? ''" :on-click-image="onClickImage" :slug="props.slug" :title="form.experienceFromCMS.title" />
    <BasicInfoSection
      class="mb-1"
      :experience-event="form.experienceEvent"
      :pre-reservation-price="props.preReservationPrice"
      :pre-reservation-price-with-guest-type="form.experienceEvent.timeSlotId ? preReservationPriceWithGuestType : undefined"
      :reservation-form-step1="form.step1"
      :reservation-form-step2="form.step2"
    />
  </div>
</template>

<script setup lang="ts">
import { TitleWithImage } from '@/wabunka-src/common/components';
import { useGlobalWabunkaReservationForm } from '@/wabunka-src/common/features/Reservation/composables/forms/useGlobalWabunkaReservationForm';
import type { ExperiencePreReservationPriceViewModel, ExperiencePreReservationPriceWithGuestTypeViewModel } from '@/wabunka-src/features/Experience';
import { UserInfoConfirmSection } from '@/wabunka-src/features/Experience';
import BasicInfoSection from '@/wabunka-src/features/Experience/subFeatures/Reservation/pages/ConfirmReservation/components/ReservationSummary/BasicInfoSection/BasicInfoSection.vue';

const { form } = useGlobalWabunkaReservationForm();
const props = defineProps<{
  slug: string;
  onClickGuestInfoChangeButton?: () => void;
  onClickImage: () => void;
  isDoneReservation?: boolean;
  preReservationPrice?: ExperiencePreReservationPriceViewModel;
  preReservationPriceWithGuestType?: ExperiencePreReservationPriceWithGuestTypeViewModel;
  thumbnailImageUrl?: string;
}>();
</script>
